<template>
  <div>
    <!-- <iframe
      allow="camera; microphone"
      @load="resizeIframe"
      ref="tradein"
      id="trade-in"
      frameBorder="0"
      class="iframe"
      :style="{ width: '100%', height: '100vh' }"
      :src="link"
    /> -->
    <div v-if="service" class="mt-2">
      <a :href="link" class="btn btn-info">
        {{ "do_price" | setText("Сделать оценку") }}</a
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      default: null,
    },
  },
  name: "trade-in",
  async created() {
    this.$loading(true);
    try {
      const req = await this.$route.query.requestId;
      if (req) {
        this.$emit("input", {
          exchange_id: req,
        });
      }
    } catch (error) {}
  },
  methods: {},
  computed: {
    service() {
      return this.data.service;
    },
    login() {
      return this.$store.state.user["email"];
    },
    password() {
      return this.$store.state.user["code"];
    },
    link: {
      get() {
        return `${
          this.service.iframe_url
        }?username=${this.$store.state.user.phone.replace("+", "")}_${
          this.$store.state.shop ? this.$store.state.shop.id : ""
        }&code=${this.$store.state.user.code}&dUrl=${
          this.$store.state.host
        }/api/redirect/trade_ins/${this.data.id}`;
      },
      set(val) {},
    },
  },
};
</script>
<style>
</style>
